import React, { createContext, useContext, useState, useEffect } from 'react';
import apiClient from '../api/apiClient';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [toolPermissions, setToolPermissions] = useState({}); // Now as an object map
    const [loading, setLoading] = useState(true);

    const fetchToolPermissions = async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            setLoading(false);
            return;
        }
        try {
            const res = await apiClient.get('/api/auth/my-tools');
            const map = (res.data || []).reduce((acc, tool) => {
                acc[tool.tool_key] = tool;
                return acc;
            }, {});
            setToolPermissions(map);
        } catch (err) {
            console.error('Error fetching tool permissions:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Init auth from localStorage
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
            fetchToolPermissions();
        } else {
            setLoading(false);
        }
    }, []);

    const login = (userData, token) => {
        if (token) localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        setUser(userData);
        fetchToolPermissions();
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
        setToolPermissions([]);
    };

    return (
        <AuthContext.Provider value={{ user, toolPermissions, login, logout, loading, refreshPermissions: fetchToolPermissions }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
